import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-shell py-20 md:py-28" aria-labelledby="experiencias" data-id="element-224" data-mp="1n0aejjtk0wxo">
      <div className="mx-auto max-w-6xl px-6 lg:px-8" data-id="element-225" data-mp="1r1m983rac8cq">
        <SectionHeading eyebrow="Experiencias" title={<span id="experiencias" data-id="element-227" data-mp="1d1bg0u2i6hoe">Mujeres que decidieron volver a sí mismas</span>} data-id="element-226" data-mp="1r02rs9tw7r9d" />

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-228" data-mp="1i1h0nqacv3wz">
          {testimonials.map((item, i) => <Reveal key={item.name} delay={i * 0.08} data-id="element-229" data-mp="141oco2q7r1sp" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-[1.75rem] border border-sand bg-ivory px-8 py-9 transition-all duration-500 hover:border-goldsoft hover:shadow-[0_30px_60px_-50px_rgba(58,51,46,0.5)]" data-id="element-230" data-mp="143995xw38ut7">
                <h3 className="font-display text-[1.45rem] font-light italic leading-snug text-ink sm:text-2xl" data-id="element-231" data-mp="2ydcy8nqya2m2">
                  «{item.headline}»
                </h3>
                <span aria-hidden="true" className="mt-5 block h-[1px] w-10 bg-goldsoft" data-id="element-232" data-mp="2uzztqolua8t5" />
                <blockquote className="mt-6 space-y-4 font-sans text-[0.93rem] font-light leading-[1.85] text-warmgray" data-id="element-233" data-mp="2q1yekerjatmy">
                  {item.paragraphs.map(p => <p key={p} data-id="element-234" data-mp="2zs13o3vjbng0">{p}</p>)}
                </blockquote>
                <figcaption className="mt-auto pt-7 font-sans text-[0.66rem] uppercase tracking-[0.18em] text-mute" data-id="element-235" data-mp="2c26t5syouayx">
                  {item.name} · {item.age}
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}